module.exports = __webpack_public_path__ + "media/images/icon-lsd-close-41c6821052a6515855a9c6ee32fcbc62.svg";